import "./notFound.css";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useWindowSize } from "react-hooks-window-size";

function NotFound() {
	const navigate = useNavigate();
	const screenSize = useWindowSize();
	const desktopView = screenSize.width > 968;

	const handleRefresh = () => {
		navigate(desktopView ? `/dashboard/calendar` : `/dashboard/event-list`);
	};

	return (
		<>
			<div className="error-page">
				<h1>404</h1>
				<p className="error-page-text">
					Oops! The page you are looking for doesn't exist
				</p>
				<button className="go-back-home-btn" onClick={handleRefresh}>
					Back to Dashboard
				</button>
			</div>
		</>
	);
}

export default NotFound;
